function normalizeFooter() {
  document.querySelectorAll('.gov-footer__logos-group li').forEach(item => {
    const image = item.querySelector('img[src="/assets/extensions/dia-theme/img/logo_dia.svg"][alt="DIA"]');
    if (image) {
      item.remove();
    }
  });
  document.querySelectorAll('img[src$="/assets/extensions/dia-theme/img/logo_eu.png"]').forEach(image => {
    image.src = '/assets/extensions/dia-theme/img/logo_eu.svg?v=3';
    image.width = 118;
    image.height = 40;
  });
  document.querySelectorAll('img[src$="/assets/extensions/dia-theme/img/logo_npo.png"]').forEach(image => {
    image.src = '/assets/extensions/dia-theme/img/logo_npo.svg?v=3';
    image.width = 100;
    image.height = 35;
  });
  document.querySelectorAll('a[href="https://designsystem.gov.cz/"]').forEach(link => {
    var _link$textContent;
    if ((_link$textContent = link.textContent) != null && _link$textContent.includes('Design system 4.2')) {
      link.textContent = link.textContent.replace('Design system 4.2', 'Design system 4.7');
    }
  });
  document.querySelectorAll('.gov-footer-link--with-icon').forEach(link => {
    var _link$textContent2;
    if (!((_link$textContent2 = link.textContent) != null && _link$textContent2.includes('helpdesk.dia.gov.cz'))) return;
    if (link.querySelector('svg.helpdesk-link')) return;
    const template = document.createElement('template');
    template.innerHTML = "\n      <svg class=\"helpdesk-link gov-icon\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\">\n        <g clip-path=\"url(#clip-helpdesk-box-arrow-up-right)\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9545 5.25C12.9545 4.83579 12.6188 4.5 12.2045 4.5H2.25C1.00736 4.5 0 5.50736 0 6.75V21.75C0 22.9926 1.00736 24 2.25 24H17.25C18.4926 24 19.5 22.9926 19.5 21.75V11.7955C19.5 11.3812 19.1642 11.0455 18.75 11.0455C18.3358 11.0455 18 11.3812 18 11.7955V21.75C18 22.1642 17.6642 22.5 17.25 22.5H2.25C1.83579 22.5 1.5 22.1642 1.5 21.75V6.75C1.5 6.33579 1.83579 6 2.25 6H12.2045C12.6188 6 12.9545 5.66421 12.9545 5.25Z\" fill=\"currentColor\"></path>\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 0.75C24 0.335786 23.6642 0 23.25 0H15.75C15.3358 0 15 0.335786 15 0.75C15 1.16421 15.3358 1.5 15.75 1.5H21.4393L9.21967 13.7197C8.92678 14.0126 8.92678 14.4874 9.21967 14.7803C9.51256 15.0732 9.98744 15.0732 10.2803 14.7803L22.5 2.56066V8.25C22.5 8.66421 22.8358 9 23.25 9C23.6642 9 24 8.66421 24 8.25V0.75Z\" fill=\"currentColor\"></path>\n        </g>\n        <defs>\n          <clipPath id=\"clip-helpdesk-box-arrow-up-right\">\n            <rect width=\"24\" height=\"24\" fill=\"white\"></rect>\n          </clipPath>\n        </defs>\n      </svg>\n    ";
    const icon = template.content.firstElementChild;
    const currentIcon = link.querySelector('.gov-icon-email, gov-icon.helpdesk-link');
    if (currentIcon) {
      currentIcon.replaceWith(icon);
    } else {
      link.prepend(icon);
    }
  });
}
export default function registerFooterNormalizer() {
  requestAnimationFrame(normalizeFooter);
  setTimeout(normalizeFooter, 0);
  setTimeout(normalizeFooter, 500);
  const observerTarget = document.getElementById('app') || document.body;
  if (observerTarget) {
    new MutationObserver(normalizeFooter).observe(observerTarget, {
      childList: true,
      subtree: true
    });
  }
}
flarum.reg.add('dia-theme', 'forum/features/footer-normalizer', registerFooterNormalizer);